import { render, staticRenderFns } from "./especie.vue?vue&type=template&id=383b0e70&"
import script from "./especie.vue?vue&type=script&lang=js&"
export * from "./especie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports